import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as inspectAPI from 'api/Inspect';
import { isEmpty } from 'utils/redux';
import { languages } from 'utils/languages';
import { PHRASE_BASED } from 'sections/inspect/constants';

const initialState = {
  searchTab: {
    pagination: {
      total_filterd_records: null,
      total_records: null,
      index: 1
    },
    data: null,
    searchedData: ''
  },
  keywordTab: {
    innerSearch: '',
    keywordsData: null,
    afterKey: '',
    slug: ''
  },
  topicTab: {
    innerSearch: '',
    topicsData: null,
    afterKey: '',
    slug: ''
  },
  selectedLanguage: 'English',
  selectedLangCode: 'en',
  selectedSearchType: PHRASE_BASED,
  ui: {
    loading: false,
    msg: ''
  },
  status: 'init',
  panelshow: true
};
const getInspectState = (state) => state.inspect;

const getInspectData = createAsyncThunk('inspect/getInspectData', async ({ filterResult, signal }) => {
  const res = await inspectAPI.getInspectData(filterResult, signal);
  return res.data?.data;
});

const getInspectKeywordInnerSearchData = createAsyncThunk('inspect/getInspectKeywordInnerSearchData', async ({ filterResult, signal }) => {
  filterResult['tab_type'] = 'keyword_tab';
  const res = await inspectAPI.getInspectInnerSearchData(filterResult, signal);
  return res.data?.data;
});

const getInspectTopicInnerSearchData = createAsyncThunk('inspect/getInspectTopicInnerSearchData', async ({ filterResult, signal }) => {
  filterResult['tab_type'] = 'topic_tab';
  const res = await inspectAPI.getInspectInnerSearchData(filterResult, signal);
  return res.data?.data;
});

const reportingSlice = createSlice({
  name: 'inspect',
  initialState: initialState,

  reducers: {
    resetState: () => {
      return initialState;
    },
    setPaginationData: (state, action) => {
      state.searchTab.pagination.index = action.payload;
    },
    setPanelShow: (state, action) => {
      state.panelshow = action.payload;
    },
    setSelectedLanguage: (state, action) => {
      state.selectedLanguage = action.payload;
      const selectedLangObj = languages?.find((item) => item.Language === action.payload);
      if (selectedLangObj) state.selectedLangCode = selectedLangObj?.Code || '';
    },
    setSearchedData: (state, action) => {
      state.searchTab.searchedData = action.payload;
    },
    setInnerKeywordSearch: (state, action) => {
      state.keywordTab.innerSearch = action.payload;
    },
    resetKeywordsData: (state) => {
      state.keywordTab.keywordsData = null;
      state.keywordTab.afterKey = null;
    },
    setInnerTopicSearch: (state, action) => {
      state.topicTab.innerSearch = action.payload;
    },
    resetTopicsData: (state) => {
      state.topicTab.topicsData = null;
      state.topicTab.afterKey = null;
    },
    setSelectedSearchType: (state, action) => {
      state.selectedSearchType = action.payload;
    }
  },

  extraReducers: {
    [getInspectData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getInspectData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      if (isEmpty(action.payload)) {
        // state.data = null;
        if (state.searchTab.pagination.index === 0) state.searchTab.data = [];
      } else {
        state.searchTab.data = action.payload;
        state.searchTab.pagination = {
          ...state.searchTab.pagination,
          total_filterd_records: action.payload?.total_filter_conversion_records || 0,
          total_records: action.payload?.total_conversion_records || 0
        };
      }
    },

    [getInspectData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getInspectKeywordInnerSearchData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getInspectKeywordInnerSearchData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      // state.keywordTab.keywordsData = action.payload;
      const data = action.payload.data;
      if (state.keywordTab.keywordsData && state.keywordTab.keywordsData?.length && data) {
        state.keywordTab.keywordsData = [...state.keywordTab.keywordsData, ...data];
      } else {
        state.keywordTab.keywordsData = action.payload?.data;
      }
      state.keywordTab.afterKey = action.payload.after_key;
      state.keywordTab.slug = action.payload.slug;
    },

    [getInspectKeywordInnerSearchData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getInspectTopicInnerSearchData.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getInspectTopicInnerSearchData.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;
      const data = action.payload.data;
      if (state.topicTab.topicsData && state.topicTab.topicsData?.length && data) {
        state.topicTab.topicsData = [...state.topicTab.topicsData, ...data];
      } else {
        state.topicTab.topicsData = action.payload?.data;
      }
      state.topicTab.afterKey = action.payload.after_key;
      state.topicTab.slug = action.payload.slug;
    },

    [getInspectTopicInnerSearchData.rejected]: (state, action) => {
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    }
  }
});

const {
  resetState,
  setPaginationData,
  setPanelShow,
  setSelectedLanguage,
  setSearchedData,
  setInnerTopicSearch,
  setInnerKeywordSearch,
  resetKeywordsData,
  resetTopicsData,
  setSelectedSearchType
} = reportingSlice.actions;

export default reportingSlice.reducer;

export {
  getInspectData,
  resetState,
  getInspectState,
  setPanelShow,
  setPaginationData,
  setSelectedLanguage,
  setSearchedData,
  setInnerTopicSearch,
  setInnerKeywordSearch,
  getInspectKeywordInnerSearchData,
  getInspectTopicInnerSearchData,
  resetKeywordsData,
  resetTopicsData,
  setSelectedSearchType
};
